<template>
    <div class="evaluation-detail">
        <div class="header">
            <div class="tab_box">
                <div class="tab_item" :class="'active_tab_item'">
                    学员素养评定
                </div>
            </div>

            <div class="header-operate">
                <el-button @click="$router.back()">返回</el-button>
                <el-button type="primary" @click="handleAddEvaluation(1)">添加细则</el-button>
                <el-button type="primary" @click="handleSubmitEvaluation">提交评定</el-button>
            </div>
        </div>

        <el-scrollbar class="learning_main">
            <el-table
                ref="tableRef"
                :data="getTableData"
                style="width: 100%; border-radius: 4px"
                size="medium"
                row-key="id"
                default-expand-all
                :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
                :header-cell-style="{ fontWeight: 'normal', color: '#333', background: '#f5f7fa' }"
                class="table-content"
                :cell-style="{ fontSize: '12px', color: '#333' }"
            >
                <el-table-column label="细则名称" width="300">
                    <template slot-scope="scope">
                        <span v-if="scope.row.level === 1">{{ scope.row.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="二级细则名称">
                    <template slot-scope="scope">
                        <span v-if="scope.row.level === 2">{{ scope.row.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="评定" width="240">
                    <template slot-scope="scope">
                        <div class="operate-column">
                            <el-button type="text" v-if="scope.row.level === 1" @click="handleAddEvaluation(2, scope.row.id)">
                                添加二级细则
                            </el-button>

                            <el-input-number
                                v-if="scope.row.level === 2"
                                v-model="scope.row.score"
                                :controls="false"
                                :min="0"
                                :max="100"
                                :size="'small'"
                            ></el-input-number>

                            <el-button type="text" v-if="!scope.row.default" @click="handleEditEvaluation(scope.row.level, scope.row)">
                                编辑
                            </el-button>

                            <el-button class="del-btn" type="text" v-if="!scope.row.default" @click="handleDeleteEvaluation(scope.row.id)">
                                删除
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-scrollbar>

        <div class="pagination">
            <el-pagination
                :current-page="pageParams.page"
                :page-size="pageParams.size"
                @current-change="handleCurrentChange"
                background
                layout="prev, pager, next"
                :total="tableData.length"
            >
            </el-pagination>
        </div>

        <el-dialog
            class="center-dialog"
            :title="dialogData.title"
            :visible.sync="dialogData.visible"
            width="30%"
            :modal="true"
            :append-to-body="true"
            :close-on-click-modal="false"
        >
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="细项名称" prop="name">
                    <el-input v-model="ruleForm.name"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="handleCloseDialog">取 消</el-button>
                <el-button type="primary" @click="handleDialogConfirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "EvaluationDetail",
    data() {
        return {
            selectClassGradId: "",
            classGradData: [], //班级列表,
            levelNum: 9,
            defaultTableData: [
                {
                    id: "1",
                    name: "目标管理",
                    level: 1,
                    default: true,
                    num: 4,
                    children: [
                        { score: undefined, level: 2, default: true, id: "1_1", name: "设定明确的学习目标" },
                        { score: undefined, level: 2, default: true, id: "1_2", name: "制定可行的计划并执行" },
                        { score: undefined, level: 2, default: true, id: "1_3", name: "定期检查目标完成情况" },
                        { score: undefined, level: 2, default: true, id: "1_4", name: "根据反馈调整目标和计划" },
                    ],
                },
                {
                    id: "2",
                    name: "批判性思维",
                    level: 1,
                    default: true,
                    num: 4,
                    children: [
                        { score: undefined, level: 2, default: true, id: "2_1", name: "能够分析问题的本质" },
                        { score: undefined, level: 2, default: true, id: "2_2", name: "提出合理的质疑和反思" },
                        { score: undefined, level: 2, default: true, id: "2_3", name: "从多角度评估信息的可靠性" },
                        { score: undefined, level: 2, default: true, id: "2_4", name: "做出基于证据的判断" },
                    ],
                },
                {
                    id: "3",
                    name: "文化素养",
                    level: 1,
                    default: true,
                    num: 4,
                    children: [
                        { score: undefined, level: 2, default: true, id: "3_1", name: "了解并尊重不同文化背景" },
                        { score: undefined, level: 2, default: true, id: "3_2", name: "掌握基本的艺术和人文知识" },
                        { score: undefined, level: 2, default: true, id: "3_3", name: "积极参与文化活动" },
                        { score: undefined, level: 2, default: true, id: "3_4", name: "具备良好的审美能力" },
                    ],
                },
                {
                    id: "4",
                    name: "信息素养",
                    level: 1,
                    default: true,
                    num: 3,
                    children: [
                        { score: undefined, level: 2, default: true, id: "4_1", name: "熟练使用信息技术工具" },
                        { score: undefined, level: 2, default: true, id: "4_2", name: "能够高效检索和筛选信息" },
                        { score: undefined, level: 2, default: true, id: "4_3", name: "辨别信息的真实性和价值" },
                    ],
                },
                {
                    id: "5",
                    name: "健康素养",
                    level: 1,
                    default: true,
                    num: 3,
                    children: [
                        { score: undefined, level: 2, default: true, id: "5_1", name: "保持良好的作息习惯" },
                        { score: undefined, level: 2, default: true, id: "5_2", name: "积极参与体育锻炼" },
                        { score: undefined, level: 2, default: true, id: "5_3", name: "具备基本的健康知识和技能" },
                    ],
                },
                {
                    id: "6",
                    name: "团队合作意识",
                    level: 1,
                    default: true,
                    num: 3,
                    children: [
                        { score: undefined, level: 2, default: true, id: "6_1", name: "在团队中主动承担责任" },
                        { score: undefined, level: 2, default: true, id: "6_2", name: "能够激励和影响他人" },
                        { score: undefined, level: 2, default: true, id: "6_3", name: "合理分配任务并协调资源" },
                        { score: undefined, level: 2, default: true, id: "6_3", name: "在决策中展现果断和公正" },
                    ],
                },
                {
                    id: "7",
                    name: "情绪智力",
                    level: 1,
                    default: true,
                    num: 3,
                    children: [
                        { score: undefined, level: 2, default: true, id: "7_1", name: "能够识别自己和他人的情绪" },
                        { score: undefined, level: 2, default: true, id: "7_2", name: "在压力下保持冷静和理性" },
                        { score: undefined, level: 2, default: true, id: "7_3", name: "善于调节情绪，避免冲动行为" },
                    ],
                },
                {
                    id: "8",
                    name: "职业素养",
                    level: 1,
                    default: true,
                    num: 3,
                    children: [
                        { score: undefined, level: 2, default: true, id: "8_1", name: "了解职业规划的基本方法" },
                        { score: undefined, level: 2, default: true, id: "8_2", name: "具备基本的职场礼仪和沟通技巧" },
                        { score: undefined, level: 2, default: true, id: "8_3", name: "展现责任感和职业道德" },
                    ],
                },
                {
                    id: "9",
                    name: "专业应用能力",
                    level: 1,
                    default: true,
                    num: 2,
                    children: [
                        { score: undefined, level: 2, default: true, id: "9_1", name: "熟练掌握专业工具或平台" },
                        { score: undefined, level: 2, default: true, id: "9_2", name: "大数据分析与应用能力" },
                    ],
                },
            ],
            tableData: [],
            dialogData: {
                visible: false,
                type: 0, // 0-无，1-一级细则，2-二级细则
                id: "",
                title: "",
            },
            ruleForm: {
                name: "",
            },
            rules: {
                name: [
                    { required: true, message: "请输入细项名称", trigger: "blur" },
                    { min: 2, max: 18, message: "长度在 2 到 18 个字符", trigger: "blur" },
                ],
            },
            pageParams: {
                page: 1,
                size: 10,
            },
        };
    },
    created() {
        this.initTableData();
    },
    mounted() {},
    computed: {
        getTableData() {
            return this.tableData.slice((this.pageParams.page - 1) * this.pageParams.size, this.pageParams.page * this.pageParams.size);
        },
    },
    methods: {
        initTableData() {
            const storageData = sessionStorage.getItem(`student_${this.$route.query.id}`);
            if (storageData) {
                this.tableData = JSON.parse(storageData);
            } else {
                this.tableData = this.defaultTableData;
            }
        },

        handleToFeatured() {
            this.$router.push({
                path: "/teachingCenter/teacherFeatured",
                query: {
                    course_id: this.$route.query.course_id,
                },
            });
        },

        handleCurrentChange(val) {
            this.pageParams.page = val;
        },

        // 评定
        evaluation(id) {},

        // 关闭弹框
        handleCloseDialog() {
            this.dialogData = {
                visible: false,
                type: 0, // 0-无，1-一级细则，2-二级细则
                id: "",
                name: "", // 细项名称
                title: "",
            };

            this.ruleForm.name = "";
            this.$refs.ruleForm?.clearValidate();
        },

        // 添加细则
        handleAddEvaluation(level, id = "") {
            if (level === 1) {
                // 一级细则
                this.dialogData.title = "新建细项";
                this.dialogData.type = 1;
                this.dialogData.visible = true;
            } else if (level === 2) {
                // 二级细则
                this.dialogData.title = "新建二级细项";
                this.dialogData.id = id;
                this.dialogData.type = 2;
                this.dialogData.visible = true;
            }
        },

        // 编辑
        handleEditEvaluation(level, row) {
            if (level === 1) {
                this.dialogData.title = "编辑细项";
            } else if (level === 2) {
                this.dialogData.title = "编辑二级细项";
            }

            this.ruleForm.name = row.name;
            this.dialogData.type = level;
            this.dialogData.id = row.id;
            this.dialogData.visible = true;
        },

        // 弹框确认按钮
        handleDialogConfirm() {
            this.$refs.ruleForm?.validate((valid) => {
                if (valid) {
                    if (this.customerValidate()) this.changeEvaluation();
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },

        // 自定义校验
        customerValidate() {
            let result = [];
            let childrenTableData = this.tableData.flatMap((item) => item.children);

            if (this.dialogData.type === 1) {
                result.push(
                    !this.tableData.some((item) => {
                        return item.id !== this.dialogData.id && item.name === this.ruleForm.name;
                    }),
                );

                result.push(
                    !childrenTableData.some((item) => {
                        return item.name === this.ruleForm.name;
                    }),
                );
            } else if (this.dialogData.type === 2) {
                result.push(
                    !this.tableData.some((item) => {
                        return item.name === this.ruleForm.name;
                    }),
                );

                result.push(
                    !childrenTableData.some((item) => {
                        return item.id !== this.dialogData.id && item.name === this.ruleForm.name;
                    }),
                );
            }

            const validateResult = result.some((item) => !item);
            if (validateResult) {
                this.$message.warning("细则名称不可重复");
            }

            return !validateResult;
        },

        // 修改细项
        changeEvaluation() {
            if (this.dialogData.type === 1) {
                if (this.dialogData.id) {
                    // 编辑
                    const changeEvaluationItem = this.tableData.find((item) => item.id === this.dialogData.id);
                    if (changeEvaluationItem) {
                        this.$set(changeEvaluationItem, "name", this.ruleForm.name);
                    }
                } else {
                    // 增加
                    const evaluationItem = {
                        id: `${this.levelNum + 1}`,
                        name: this.ruleForm.name,
                        level: 1,
                        default: false,
                        num: 0,
                        children: [],
                    };
                    this.levelNum += 1;
                    this.tableData.push(evaluationItem);
                }
            } else if (this.dialogData.type === 2) {
                const idArr = this.dialogData.id.split("_");
                if (idArr.length === 1) {
                    // 增加
                    const changeEvaluationItem = this.tableData.find((item) => item.id === idArr[0]);
                    if (changeEvaluationItem) {
                        const evaluationChildrenItem = {
                            score: undefined,
                            level: 2,
                            default: false,
                            id: `${idArr[0]}_${changeEvaluationItem.num + 1}`,
                            name: this.ruleForm.name,
                        };
                        changeEvaluationItem.num += 1;
                        changeEvaluationItem.children.push(evaluationChildrenItem);
                    }
                    this.$nextTick(() => {
                        this.$refs.tableRef?.toggleRowExpansion(changeEvaluationItem, true);
                    });
                } else if (idArr.length > 1) {
                    // 编辑
                    const changeEvaluationItem = this.tableData.find((item) => item.id === idArr[0]);
                    if (changeEvaluationItem) {
                        const changeIndex = changeEvaluationItem.children?.findIndex((item) => item.id === this.dialogData.id);
                        this.$set(changeEvaluationItem.children[changeIndex], "name", this.ruleForm.name);
                    }
                }
            }

            this.handleCloseDialog();
        },

        // 删除细项
        handleDeleteEvaluation(id) {
            this.$confirm("是否删除评定细项，删除完将无法恢复", "删除评定细项", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                const idArr = id.split("_");
                if (idArr.length === 1) {
                    const delIndex = this.tableData.findIndex((item) => item.id === idArr[0]);
                    if (delIndex > -1) {
                        this.tableData.splice(delIndex, 1);
                    }
                } else if (idArr.length > 1) {
                    const evaluationItem = this.tableData.find((item) => item.id === idArr[0]);
                    if (evaluationItem) {
                        const delIndex = evaluationItem.children?.findIndex((item) => item.id === id);
                        if (delIndex > -1) {
                            evaluationItem.children.splice(delIndex, 1);
                        }
                    }
                }
            });
        },

        // 提交准则
        handleSubmitEvaluation() {
            // 存储准则列表到缓存种
            sessionStorage.setItem(`student_${this.$route.query.id}`, JSON.stringify(this.tableData));

            // 获取已评定的id，没有则新建
            const evaluationIds = sessionStorage.getItem("evaluationIds");
            if (evaluationIds) {
                const idSet = new Set(JSON.parse(evaluationIds));
                idSet.add(this.$route.query.id);

                sessionStorage.setItem("evaluationIds", JSON.stringify([...idSet]));
            } else {
                sessionStorage.setItem("evaluationIds", JSON.stringify([this.$route.query.id]));
            }

            this.$router.back();

            this.$message.success("提交评定成功");
        },
    },
};
</script>

<style scoped lang="scss">
.evaluation-detail {
    // margin-top: 16px;
    background-color: #ffffff;
    height: calc(100% - 50px);
    box-sizing: border-box;
    // padding: 28px 28px 30px 36px;
    padding-inline: 28px 36px;
    overflow: hidden;

    .header {
        width: 100%;
        // padding: 0 44px;
        border-bottom: 1px solid #eeeeee;
        display: flex;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        line-height: 21px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        .tab_box {
            display: flex;
            .tab_item {
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 18px;
                color: #f23b2f;
                line-height: 21px;
                padding-bottom: 21px;
                text-align: center;
                font-style: normal;
                text-transform: none;
            }
            .active_tab_item {
                color: #f23b2f;
                border-bottom: 3px solid #f23b2f;
            }
        }

        .header-operate {
            display: flex;
            gap: 16px;
        }

        .el-button {
            width: 96px;
            height: 38px;
            font-size: 16px;
            color: #606266;
            display: flex;
            justify-content: center;
            align-items: center;

            &.el-button--primary {
                color: #ffffff;
            }
        }

        .el-button + .el-button {
            margin-left: 0;
        }
    }

    .learning_main {
        width: 100%;
        height: calc(100% - 46px - 60px);
        // padding-bottom: 30px;
        box-sizing: border-box;
        margin-top: 20px;
        background-color: #ffffff;

        ::v-deep .el-scrollbar__wrap {
            overflow-x: hidden;
        }

        .el-table {
            &::before {
                display: none;
            }

            .operate-column {
                display: flex;
                align-items: center;
                gap: 6px;
            }

            ::v-deep .el-button {
                color: #006eff;
            }

            ::v-deep .cell {
                color: #3e3e3e;
                font-size: 14px;
            }

            .del-btn {
                color: #ff2626;
            }

            .el-input-number--small {
                width: 120px;
            }

            ::v-deep .el-input-number.is-without-controls .el-input__inner {
                text-align: left;

                &:focus {
                    border-color: #409eff;
                }
            }
        }
    }

    .pagination {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 50px;
    }

    ::v-deep .el-input__inner {
        background: #fff !important;
    }
    ::v-deep .el-select .el-input.is-focus .el-input__inner {
        border-color: #409eff !important;
    }
}
</style>
